import { Button, TextField } from '@mui/material'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const CustomTagRowWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 3px;
  border: 1px solid ${colors.lightGrey};
  background: #f8f8f8;
  padding: 8px;
  margin-bottom: 8px;

  ${(props: { $grey: boolean }) => `${
    props.$grey
      ? `
        background:${colors.lightGrey};
        `
      : null
  }
  `}

  ${(props: { $isDragged: boolean }) => `${
    props.$isDragged
      ? `
          background: ${colors.grey};
          opacity: 0.5;
        `
      : null
  }
 `}
`

export const TagDescriptionWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`

export const AddNewStatusButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  gap: 8px;
  cursor: pointer;
  color: ${colors.black};
  font-size: 14px;
  border-radius: 3px;
  border: 1px solid ${colors.lightGrey};
`

export const NoMoreStatusesLeftMessage = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  padding: 8px;
  gap: 8px;
  color: #ababab;
  font-size: 14px;
  border-radius: 3px;
  border: 1px solid ${colors.lightGrey};
`

export const CustomTagNameWrapper = styled('div')`
  padding: 0 5px;
  white-space: break-spaces;
  min-height: 25px;
  display: flex;
  align-items: center;
  word-break: break-all;
  flex: 1 1 auto;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 2px;

  &:hover {
    border: 1px solid ${colors.darkGray};
  }
`

export const TagColorPickerWrapper = styled('div')`
  padding: 3px;
  display: flex;
  align-items: center;
  gap: 3px;
  border-radius: 3px;
  border: 1px solid ${colors.lightGrey};
  cursor: pointer;
  background: ${colors.white};
`

export const EditCustomTagTextField = styled(TextField)`
  width: 100%;

  & .MuiInputBase-root {
    min-height: 20px;
  }

  & .MuiInputBase-input {
    padding: 5px;
  }
`

export const TagsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`
